import { collection, query, where, doc, getDocs } from 'firebase/firestore';
import { useMemo } from 'react';
import { useFirebase } from '../contexts/FirebaseContext';

const InvitationUtils = () => {
  const { db } = useFirebase();

  const findInvitationForGameAndUser = async (game, user) => {
    try {
      const invitationsRef = collection(db, 'games', game.id, 'invitations');
      const q = query(invitationsRef, where("user", "==", doc(db, "users", user.uid)));
      const querySnapshot = await getDocs(q);
      
      if (!querySnapshot.empty) {
        const invitationDoc = querySnapshot.docs[0];
        return { ...invitationDoc.data(), id: invitationDoc.id };
      }
      
      return null;
    } catch (error) {
      console.error('Error finding invitation:', error);
      throw error;
    }
  }

  const utils = useMemo(() => ({
    findInvitationForGameAndUser
  }), 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);

  return utils;
};

export function useInvitationUtils() {
  return InvitationUtils();
}

